import { styled } from '@mui/material/styles';

export const Border = styled('div')(({ theme }) => ({
  borderRight: `1px solid ${theme.palette.grey[200]}`,
  width: '0',
  height: '80px',
  margin: theme.spacing(0, 2),
}));

export const Card = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',
  minWidth: '150px',
}));

export const Cardset = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  marginTop: theme.spacing(2),
}));

export const Highlights = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'baseline',
  gap: theme.spacing(0.5),
  '& > *': {
    display: 'flex',
    alignItems: 'center',
    fontFamily: theme.typography.bold.fontFamily,
    gap: theme.spacing(0.5),
  },
}));
